import RenewalItem from "./RenewalItem";

const RenewalsList = ({ renewals, onRenewalChange, onUnpaidRequest }) => {
  if (renewals.length === 0) {
    return (
      <p className="text-sm text-slate-400 text-center py-4 border border-dashed rounded-lg">
        No renewals yet. Enter sign up date & price above to auto-generate.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      {renewals.map((r, i) => (
        <RenewalItem
          key={i}
          renewal={r}
          index={i}
          isLast={i === renewals.length - 1}
          onRenewalChange={onRenewalChange}
          onUnpaidRequest={onUnpaidRequest}
        />
      ))}
    </div>
  );
};

export default RenewalsList;
